import { createActionTypes } from '../../shared/actions';
import { ACTIONS_NAMESPACE } from '../../shared/constants';

export const endpoint = {
  template: '/inventory',
  upload: '/inventory'
};

export const tableName = 'dashboardMassUpload';

export const typeExportTemplate = 'EXPORT_TEMPLATE';

export const typeUploadFile = 'UPLOAD_FILE';

export const namespace = `${ACTIONS_NAMESPACE}/DashboardMassUpload`;

const exportTemplate = createActionTypes(typeExportTemplate, namespace);
const uploadFile = createActionTypes(typeUploadFile, namespace);

export default {
  ...exportTemplate,
  ...uploadFile
};



// WEBPACK FOOTER //
// ./src/containers/DashboardMassUpload/constants.js